import { AlertTriangle } from 'lucide-react';

import { useBugReport } from '../model/bug-report-context';

/**
 * Кнопка ⚠ «Сообщить об ошибке»: справа внизу, слева от кнопки ассистента;
 * если ассистент недоступен — на его месте. Доступна всем сотрудникам staff SPA.
 */
export function BugReportButton({ assistantAvailable }: { assistantAvailable: boolean }) {
  const { openBugReport } = useBugReport();
  return (
    <button
      type="button"
      className={`fixed bottom-5 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-amber-500 text-white shadow-lg transition-transform hover:scale-105 ${
        assistantAvailable ? 'right-20' : 'right-5'
      }`}
      aria-label="Сообщить об ошибке"
      title="Сообщить об ошибке"
      data-testid="bug-report-button"
      onClick={() => openBugReport({ source: 'dock' })}
    >
      <AlertTriangle size={22} aria-hidden />
    </button>
  );
}
